import { defineStore } from 'pinia';
import { ref } from 'vue';

// Manual escape hatch for MJPEG previews that are stuck on a dead connection. Bumping
// the generation is picked up by every mounted stream (see use_mjpeg_stream), which
// then drops its current connection and opens a fresh one.
const useStreamsStore = defineStore('streams', () => {
  const generation = ref(0);

  function reloadAll() {
    generation.value += 1;
  }

  return {
    generation,

    reloadAll,
  };
});

export default useStreamsStore;
